import React from 'react';

const ShareSimpleChunkySvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M15 4l-1.4 1.4L16.2 8H11c-3.9 0-7 3.1-7 7v5h2v-5c0-2.8 2.2-5 5-5h5.2l-2.6 2.6L15 14l5-5-5-5z"
        />
    </svg>
);

ShareSimpleChunkySvg.displayName = 'ShareSimpleChunkySvg';
export default ShareSimpleChunkySvg;
